import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { EmptyLayoutComponent } from 'app/layout/layouts/empty/empty.component';
import { DynSidebarComponent } from '@shared/components/dyn-sidebar/dyn-sidebar.component';

@NgModule({
    declarations: [EmptyLayoutComponent],
    imports: [RouterModule, SharedModule, DynSidebarComponent],
    exports: [EmptyLayoutComponent]
})
export class EmptyLayoutModule {}
